"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Svg = _styledComponents.default.svg.attrs({
  width: '24',
  height: '22',
  viewBox: '0 0 24 22',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fill: ", "\n"])), function (props) {
  return props.theme.primaryColor;
});
var NotCompactIcon = function NotCompactIcon() {
  return /*#__PURE__*/_react.default.createElement(Svg, null, /*#__PURE__*/_react.default.createElement("rect", {
    height: "4",
    rx: "1",
    width: "24"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    height: "4",
    rx: "1",
    width: "24",
    y: "6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    height: "4",
    rx: "1",
    width: "24",
    y: "12"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    height: "4",
    rx: "1",
    width: "24",
    y: "18"
  }));
};
var _default = exports.default = (0, _react.memo)(NotCompactIcon);